module.exports = __webpack_public_path__ + "assets/0f4bf6a75feede2962af03b216852fc1.ttf";